import hrms14xLabels from 'assets/labels/hrms14x'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hrms14xLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dteinput: moment().format('DD/MM/YYYY HH:mm'),
        numseq: faker.random.number().toString().substr(0, 1),
        staappr: '',
        desc_staappr: mockStatus[staappr],
        routeno: faker.random.number(),
        desc_routeno: 'Description Route no',
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remark: 'Test HRMS14X',
        desc_codempap: faker.name.findName(),
        approvno: '',
        typreq: '',
        dtework: '',
        dtereq: '',
        codlon: '',
        codcomp: '',
        codpos: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  popupStatus () {
    let mockPopupStatusRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockPopupStatusTotal = 3
    for (var i = 1; i <= mockPopupStatusTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockPopupStatusRows.push({
        seqno: i,
        typeapp: 'พนักงาน',
        dtesnd: moment().format('DD/MM/YYYY'),
        dteapph: moment().format('DD/MM/YYYY HH:mm'),
        desc_codempap: faker.name.findName(),
        staappr: '',
        status: mockStatus[staappr],
        remark: 'Test Remark'
      })
    }

    return {
      total: mockPopupStatusTotal,
      rows: mockPopupStatusRows
    }
  },
  popupStatusEdit () {
    let mockPopupStatusEditRows = []
    const mockPopupStatusEditTotal = 1
    for (var i = 1; i <= mockPopupStatusEditTotal; i++) {
      mockPopupStatusEditRows.push({
        seqno: i,
        codcompap: faker.lorem.word(),
        codposap: faker.name.jobTitle(),
        codempap: faker.name.jobType()
      })
    }

    return {
      total: mockPopupStatusEditTotal,
      rows: mockPopupStatusEditRows
    }
  },
  popupRouteNo () {
    let mockPopupRouteNoRows = []
    const mockPopupRouteNoTotal = 1
    for (var i = 1; i <= mockPopupRouteNoTotal; i++) {
      mockPopupRouteNoRows.push({
        id: i,
        namtype: 'รหัสพนักงาน',
        codempap: faker.lorem.word(),
        desc_codempap: faker.name.findName(),
        desc_codcompap: faker.name.jobType(),
        desc_codposap: faker.name.jobTitle(),
        num: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        status: 'ตาม Flow'
      })
    }

    return {
      total: mockPopupRouteNoTotal,
      rows: mockPopupRouteNoRows
    }
  },
  save () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms14x/mocker.js